import * as actionTypes from "../constants";

const initialState = {
  loading: true,
  error: null,
  record: null,
  savingBehavioural: false,
  behaviouralSaved: false,
  // admin advance-search (searching other users' behavioural data)
  behaviourals: [],
  advanceSearchLoading: false,
};

export default function behavioural(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.FETCH_BEHAVIOURALS:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.GET_BEHAVIOURALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        record: payload.record,
        savingBehavioural: false,
        behaviouralSaved: false,
      };

    case actionTypes.SAVING_BEHAVIOURAL:
      return {
        ...state,
        savingBehavioural: true,
        behaviouralSaved: false,
      };

    case actionTypes.ADD_BEHAVIOURAL_SUCCESS:
      return {
        ...state,
        savingBehavioural: false,
        behaviouralSaved: true,
        record: payload,
      };

    case actionTypes.GET_BEHAVIOURALS_FAIL:
    case actionTypes.ADD_BEHAVIOURAL_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        savingBehavioural: false,
        behaviouralSaved: false,
      };

    case actionTypes.ADVANCE_SEARCH_REQUEST_BEHAVIOURAL:
      return {
        ...state,
        advanceSearchLoading: true,
      };

    case actionTypes.GET_ADVANCE_SEARCH_BEHAVIOURAL_SUCCESS:
      return {
        ...state,
        behaviourals: payload,
        advanceSearchLoading: false,
      };

    case actionTypes.GET_ADVANCE_SEARCH_BEHAVIOURAL_FAIL:
      return {
        ...state,
        advanceSearchLoading: false,
      };

    default:
      return state;
  }
}
